<nb-card class="lost-equipment-details-modal">
  <nb-card-header>
    <h5>Lost Equipment</h5>
    <div class="header-controls">
      <!-- Book Value/Replacement Cost Toggle -->
      @if (!isLoading && !error && lostEquipmentDetails?.totalCount > 0) {
        <nb-button-group
          >
          <button
            nbButton
            [status]="displayMode === 'bookValue' ? 'primary' : 'basic'"
            size="small"
            (click)="toggleDisplayMode('bookValue')"
            >
            Book Value
          </button>
          <button
            nbButton
            [status]="displayMode === 'replacementCost' ? 'primary' : 'basic'"
            size="small"
            (click)="toggleDisplayMode('replacementCost')"
            >
            Replacement Cost
          </button>
        </nb-button-group>
      }
      <button nbButton ghost status="basic" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <!-- Loading State -->
    @if (isLoading) {
      <div class="loading-container">
        <nb-spinner status="primary" size="large"></nb-spinner>
        <!-- <p>Loading lost equipment details...</p> -->
      </div>
    }

    <!-- Error State -->
    @if (error && !isLoading) {
      <div class="error-container">
        <nb-icon icon="alert-circle-outline" status="danger"></nb-icon>
        <p>{{ error }}</p>
        <button nbButton status="primary" size="small" (click)="loadData()">
          Retry
        </button>
      </div>
    }

    <!-- No Data State -->
    @if (!isLoading && !error && lostEquipmentDetails?.totalCount === 0) {
      <div
        class="no-data-container"
        >
        <nb-icon icon="checkmark-circle-outline" status="success"></nb-icon>
        <p>No lost equipment found for the selected filters.</p>
      </div>
    }

    <!-- Data Display -->
    @if (
      !isLoading &&
      !error &&
      lostEquipmentDetails &&
      lostEquipmentDetails.totalCount > 0
      ) {
      <div
        class="data-container"
        >
        <!-- Treemap Chart Section -->
        <div class="treemap-section">
          <div #treemapContainer class="treemap-container"></div>
        </div>
        <!-- Two Column Layout: Location Breakdown & Top Categories -->
        <div class="details-grid">
          <!-- Location Breakdown Section -->
          <div class="location-breakdown-section">
            <div class="section-header">
              <h6>
                <nb-icon icon="pin-outline"></nb-icon>
                Top Locations
              </h6>
            </div>
            <div class="location-list">
              @for (
                location of lostEquipmentDetails.byLocation; track
                location; let i = $index) {
                <div
                  class="location-item"
                  >
                  <div class="location-name">
                    {{ location.locationNum }}
                  </div>
                  <div class="location-stats-row">
                    <div
                      class="location-bar"
                      [style.width]="getLocationBarWidth(location)"
                      style="background-color: #42a5f5"
                    ></div>
                    <span class="stat-value">
                      {{ formatCount(location.totalCount) }}
                      /
                      <span class="stat-secondary"
                        >{{
                        displayMode === 'bookValue'
                        ? formatCurrency(location.totalBookValue)
                        : formatCurrency(location.totalReplacementCost)
                        }}
                        ({{ getLocationPercentage(location) | number: '1.0-0' }}%)
                      </span>
                    </span>
                  </div>
                </div>
              }
            </div>
          </div>
          <!-- Top Categories Section -->
          <div class="top-categories-section">
            <div class="section-header">
              <h6>Top Categories</h6>
            </div>
            <div class="categories-list">
              @for (category of getTopCategories(); track category; let i = $index) {
                <div
                  class="category-item"
                  >
                  <div class="category-left">
                    <span
                      class="category-color-dot"
                      [style.background-color]="getCategoryColor(i)"
                    ></span>
                    <span class="category-name">{{ category.category }}</span>
                  </div>
                  <div class="category-right">
                    <span class="category-value">
                      {{ formatCount(category.count) }}
                      /
                      <span class="stat-secondary"
                        >{{
                        displayMode === 'bookValue'
                        ? formatCurrency(category.bookValue)
                        : formatCurrency(category.replacementCost)
                        }}
                        ({{ getCategoryPercentage(category) | number: '1.0-0' }}%)
                      </span>
                    </span>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </nb-card-body>
  <nb-card-footer>
    <button nbButton status="basic" (click)="close()">Close</button>
  </nb-card-footer>
</nb-card>
